import ky from 'ky';
import { ProxyUrl } from '../core/ProxyUrl.js';


const httpClient = ky.create();

// define this in .env
const SAFE_URL_PROXY = url => {
  return ProxyUrl.getProxiedUrl(url);
};

export const SURL = (url) => SAFE_URL_PROXY(url);

/**
 * Provides a simple and adaptable way to create and handle HTTP requests.
 * The RequestOptions interface defines the configuration options.
 */
export class HttpRequest {
  /**
   *
   */
  static get = (url, options) => httpClient.get(SAFE_URL_PROXY(url), options);
  /**
   *
   */
  static post = (url, options) => httpClient.post(SAFE_URL_PROXY(url), options);
  /**
   *
   */
  static put = (url, options) => httpClient.put(SAFE_URL_PROXY(url), options);
  /**
   *
   */
  static patch = (url, options) => httpClient.patch(SAFE_URL_PROXY(url), options);
  /**
   *
   */
  static head = (url, options) => httpClient.head(SAFE_URL_PROXY(url), options);
  /**
   *
   */
  static delete = (url, options) => httpClient.delete(SAFE_URL_PROXY(url), options);
}
